import {combineReducers} from 'redux';
import ui from './ui/uiReducer.js';
import forms from './forms/formsReducer.js';
import event from './event/eventReducer.js';
import account from './account/accountReducer.js';
import user from './user/userReducer.js';
import auth from './auth/authReducer.js';
import suggestions from './suggestions/suggestionsReducer.js';
import cluster from './cluster/clusterReducer.js';
import mailing from './mailing/mailingReducer.js';
import ratings from './ratings/ratingsReducer.js';
import categories from './categories/categoriesReducer';
import preparingEvent from './preparingEvent/preparingEventReducer.js';
import crowds from './crowds/crowdsReducer';
import team from './team/teamReducer';
import tickets from './tickets/ticketsReducer';
import security from './security/securityReducer';
import supplier from './supplier/supplierReducer';
import attendance from './attendance/attendanceReducer';
import publish from './publish/publishReducer.js';
import branding from './branding/brandingReducer.js';
import languages from './languages/languagesReducer.js';
import design from './design/designReducer.js';
import realtime  from './realtime/realtimeReducer.ts';
import realtimeAccount from './realtimeAccount/realtimeAccountReducer.ts';
import cash  from './cash/cashReducer.ts';
import promotion from './promotion/promotionReducer.tsx';
import promotionSummary from './promotionSummary/promotionSummaryReducer.ts';
import avenueStats from './avenueStats/avenueStatsReducer.ts';
import management from './management/managementReducer.ts';
import subscription from './subscription/subscriptionReducer.js';
import timetable from './timetable/timetableReducer';
import crm from './crm/crmReducer.js';
import appPlus from './appPlus/appPlusReducer.js';
import eTicket from './eTicket/eTicketReducer';

export default combineReducers({
    account,
    appPlus,
    attendance,
    auth,
    categories,
    cluster,
    crm,
    crowds,
    eTicket,
    event,
    forms,
    mailing,
    preparingEvent,
    publish,
    ratings,
    security,
    suggestions,
    supplier,
    team,
    tickets,
    timetable,
    ui,
    user,
    branding,
    languages,
    design,
    realtime,
    realtimeAccount,
    promotion,
    promotionSummary,
    avenueStats,
    cash,
    management,
    subscription
});
